import React, { useState, useEffect } from "react";
import {VsiBubble, VsiH4,} from "../../../../styled/App.styled";
import { useDataWithRoute, useTitleFromComponent } from "../../../../utils/hooks";
import { useVsiAppContext } from "../../../../stores/VsiApp";
import Grid from "../../../../components/Grid";
import { switchesZoneDetail } from "../../../../utils/gridColumnDefs/switches/switchesSummary";
import { useSearchParams } from "react-router-dom";
import {Card, Spinner} from "reactstrap";

export default function SwitchZoneDetail({ context, title }) {
	useTitleFromComponent(`${context} / ${title}`);
	const [searchParams] = useSearchParams();
	const { theme, client, periodId } = useVsiAppContext();
	
	const [data, { isLoading }] = useDataWithRoute(`/api/v6/report/switch_zone_detail_proc?client_id=${client.clientId}&period_id=${periodId}&switch_name=${searchParams.get("switch_name")}`)
	
	const [chartData, setChartData] = useState([]);
	
	useEffect(() => {
        setChartData(data?.recordset);
	}, [data]);
	
	return (
		<Card className={`report-card p-2 nav-card-${theme}`}>
			<VsiH4>SAN Switch Zone Detail - {searchParams.get("switch_name")}</VsiH4>
            {isLoading ? <Spinner color={"primary"}/> :
				<VsiBubble>
					<Grid addStyle data={chartData}
						columnDefs={switchesZoneDetail}
						isLoading={isLoading} />
				</VsiBubble>}
		</Card>
	)
}
